type Listener<T> = (value: T) => void

type Emitter<T> = {
	readonly on: (listener: Listener<T>) => () => void
	readonly emit: (value: T) => void
}

const createEmitter = <T = void>(): Emitter<T> => {
	const listeners = new Set<Listener<T>>()

	return {
		on: listener => {
			listeners.add(listener)

			return () => {
				listeners.delete(listener)
			}
		},
		emit: value => {
			for (const listener of listeners) listener(value)
		},
	}
}

export { createEmitter }
export type { Emitter, Listener }
